import {etsySettings} from '@coolcolduk/etsy';
import {fillerArray} from '@coolcolduk/util';

export const ETSY_SEO_CSV_HEADER = [
  'listingId',
  'title',
  ...fillerArray((i) => `tag${i + 1}`, etsySettings.listing.tags.maxCount),
  'favourite',
  'view',
  'last update',
];

/**
 * create a etsy seo csv header
 * @returns
 */
export default function getEtsySeoCsvHeader() {
  return ETSY_SEO_CSV_HEADER.join(',');
}
